const langs = [
  { code: "it", path: "" },
  { code: "en", path: "en" },
]

// export with CommonJS for gatsby-node.js
module.exports = langs
